import React from 'react';
import { pure } from 'recompose';
import moment from 'moment';
import 'moment/locale/ru';
import './Home.css';
import Map from '../../containers/Map';
import SearchBox from '../../containers/SearchBox';
import Calendar from '../Calendar';
import ToolButton from '../ToolButton';
import AdsPopover from '../AdsPopover';
import { UsersTool, VideoTool } from '../../containers/tools';
import SelectionModeButton from '../../containers/SelectionModeButton';

moment.locale('ru');

const tools = {
  users: {
    glyph: 'fontawesome-user',
    value: 'Расклейщики',
    tool: UsersTool,
  },
  video: {
    glyph: 'fontawesome-film',
    value: 'Видео',
    tool: VideoTool,
  },
  /*
  reports: {
    glyph: 'fontawesome-list-alt',
    value: 'Отчеты',
  },
  ads: {
    glyph: 'fontawesome-list-alt',
    value: 'Объявления',
  },
  */
};

const Home = ({
  selectedTool,
  videoToolSelected,
  onSelectDay,
  onSelectUsersTool,
  onSelectVideoTool,
  onCloseVideoTool,
  // onSelectReportsTool,
  // onSelectAdsTool,
  onCloseTool,
  onLogout,
}) => {
  const Tool = tools[selectedTool] && tools[selectedTool].tool;
  return (
    <div className="Home">
      <Map />
      <div className="header">
        <div className="AdsLogo" />
        <SearchBox />
        <Calendar onChange={onSelectDay} />
        <SelectionModeButton />
        <div className="user-group">
          <ToolButton
            {...tools.users}
            toggled={selectedTool === 'users'}
            onClick={onSelectUsersTool}
          />
          <ToolButton
            {...tools.video}
            toggled={videoToolSelected}
            onClick={onSelectVideoTool}
          />
          {/*
          <ToolButton
            {...tools.reports}
            toggled={selectedTool === 'reports'}
            onClick={onSelectReportsTool}
          />
          <ToolButton
            {...tools.ads}
            toggled={selectedTool === 'ads'}
            onClick={onSelectAdsTool}
          />
          */}
          <ToolButton glyph="fontawesome-signout" onClick={onLogout} />
        </div>
      </div>
      <div className="workspace">
        <div className="map">
          {videoToolSelected && <VideoTool onClose={onCloseVideoTool} />}
        </div>
        <div className="tool">
          {Tool && <Tool onClose={onCloseTool} />}
        </div>
      </div>
      <AdsPopover />
    </div>
  );
};

export default pure(Home);



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx